// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BzsA7","optionBtn":"styles_optionBtn__ElDGG"};